import React from "react";
import App from "./App";
import GrommetApp from "grommet/components/App";
import { Provider } from "react-redux";
import { Route, Switch } from "react-router"; // react-router v4
import { ConnectedRouter } from "connected-react-router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { history } from "./store/configureStore";
import recordEvent from "./analytics";

const Routes = ({ store }) => {
  return (
    <I18nextProvider i18n={i18n}>
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <GrommetApp inline={true} centered={false}>
            <Switch>
              <Route
                path="/"
                render={props => (
                  <App
                    {...props}
                    online={true}
                    store={store}
                    recordEvent={recordEvent}
                  />
                )}
              />
            </Switch>
          </GrommetApp>
        </ConnectedRouter>
      </Provider>
    </I18nextProvider>
  );
};

export default Routes;
